import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppointmentModule } from '@app/my-zone/shared/appointment';
import { ClaimNotificationModule } from '@app/my-zone/shared/claim-notification';
import { DamageClaimTitleModule } from '@app/my-zone/shared/damage-claim-title';
import { InvolvedPartiesModule } from '@app/my-zone/shared/involved-parties';
import { MailboxModule } from '@app/my-zone/shared/mailbox';
import { PaperworkModule } from '@app/my-zone/shared/paperwork';
import { PendingActionsModule } from '@app/my-zone/shared/pending-actions';
import { PhotoModule } from '@app/my-zone/shared/photo';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { UiModule } from '@app/shared/ui/ui.module';
import { UxModule } from '@app/shared/ux/ux.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { DamageClaimRoutingModule, routedComponents } from './damage-claim-routing.module';
import { DamageClaimService } from './damage-claim.service';

@NgModule({
    declarations: [
        ...routedComponents,
    ],
    imports: [
        CommonModule,
        PipesModule,
        LazyLoadImageModule,
        DamageClaimRoutingModule,
        InvolvedPartiesModule,
        PhotoModule,
        MailboxModule,
        AppointmentModule,
        PaperworkModule,
        UiModule,
        UxModule,
        PendingActionsModule,
        ClaimNotificationModule,
        DamageClaimTitleModule,
    ],
    providers: [
        DamageClaimService,
    ],
})
export class DamageClaimModule {}
